module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/12533519dd0802f603e692afc907ef52.png";